import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, Modal, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { analytics } from 'app/utils/segment';
import { pubSub } from 'utils/pubSub';
import InputField from '../../util/InputField';
import styles from '../style/companyModal.module.scss';
const validate = (values) => {
    const errors = {};
    if (values === undefined || values === null) {
        return errors;
    }
    if (!values.name) {
        errors.name = 'Required';
    }
    else if (values.name.length <= 1) {
        errors.name = 'Must be 2 characters or more';
    }
    return errors;
};
const buildCompany = (values, companyId) => {
    let company = {};
    if (typeof companyId !== 'string') {
        company = {
            name: values.name,
            user_ids: [],
        };
    }
    else {
        company = {
            updates: {
                name: values.name,
            },
            deletes: [],
        };
    }
    return company;
};
class CompanyModal extends Component {
    constructor(props) {
        super(props);
        this.handleSaveClick = this.handleSaveClick.bind(this);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.ui.isCompanyModalShown === false &&
            this.props.ui.isCompanyModalShown === true) {
            const { companyId } = this.props;
            if (companyId !== undefined &&
                companyId !== null &&
                typeof companyId === 'string') {
                this.props.getRelatedUsers(companyId); // fetch users.
            }
        }
    }
    componentDidMount() {
        const { companyId } = this.props;
        if (companyId !== undefined &&
            companyId !== null &&
            typeof companyId === 'string') {
            this.props.getRelatedUsers(companyId); // fetch users.
        }
    }
    handleSaveClick(values) {
        const { companyId, addCompany, editCompany, destroy, hideModal } = this.props;
        analytics.companyModalFormSubmitted({
            mode: companyId === null ? 'add' : 'edit',
        });
        if (companyId === null) {
            addCompany(buildCompany(values))
                .then(() => {
                const name = values.name ? values.name : '';
                const options = {
                    title: 'Company saved',
                    text: `The company "${name}" is saved`,
                    className: 'success',
                    time: 5000,
                    icon: 'i-done',
                };
                this.props.notificationAdd(options);
                destroy();
                hideModal();
                pubSub.publish('companyModalCompanyAdded');
            })
                .catch((e) => {
                console.warn('Error', e);
                const options = {
                    title: 'En error occurred',
                    text: 'Company could not be saved',
                    className: 'danger',
                    icon: 'i-exclamation',
                };
                this.props.notificationAdd(options);
            });
        }
        else {
            editCompany({
                companyId: companyId,
                patch: buildCompany(values, companyId),
            })
                .then(() => {
                const name = values.name ? values.name : '';
                const options = {
                    title: 'Company saved',
                    text: `The company "${name}" is updated`,
                    className: 'success',
                    time: 5000,
                    icon: 'i-done',
                };
                this.props.notificationAdd(options);
                destroy();
                hideModal();
            })
                .catch((e) => {
                console.warn('Error', e);
                const options = {
                    title: 'En error occurred',
                    text: 'Company could not be updated',
                    className: 'danger',
                    icon: 'i-exclamation',
                };
                this.props.notificationAdd(options);
            });
        }
    }
    render() {
        let labelClass = 'hidden';
        const { initialValues, meta, ui, companyId, hideModal, handleSubmit, asyncValidating, destroy, pristine, } = this.props;
        if (pristine === false && initialValues !== null) {
            labelClass = '';
        }
        return (_jsxs(Modal, Object.assign({ className: styles.modal, isOpen: ui.isCompanyModalShown, onClose: () => {
                destroy();
                hideModal();
            } }, { children: [_jsx(ModalHead, { title: _jsxs(_Fragment, { children: [companyId === null
                                ? 'Add a new company'
                                : 'Edit ' +
                                    (typeof initialValues.name === 'string'
                                        ? initialValues.name
                                        : ''), _jsx("label", Object.assign({ className: 'unsaved-changes-label label label-danger clickable-cursor ' +
                                    labelClass }, { children: "Unsaved changes" }))] }), onClose: () => {
                        destroy();
                        hideModal();
                    } }), _jsx(ModalBody, { children: _jsx("form", Object.assign({ id: "companyModalForm", onSubmit: handleSubmit(this.handleSaveClick) }, { children: _jsx(FlexBox, { children: _jsx(Field, { displayName: "Name", name: "name", component: InputField, type: "text", className: "mb0", placeholder: "Company name..." }) }) })) }), _jsx(ModalFoot, { confirmName: companyId === null
                        ? `Add new company`
                        : `Save ${typeof initialValues.name === 'string'
                            ? initialValues.name
                            : ''}`, confirmProps: {
                        disabled: asyncValidating !== false || meta.asyncStatus === 'loading'
                            ? true
                            : false,
                        type: 'submit',
                        form: 'companyModalForm',
                    }, confirmOnClick: () => {
                        // No action needed.
                    }, cancelOnClick: () => {
                        destroy();
                        hideModal();
                    } })] })));
    }
}
export default reduxForm({
    form: 'companyModalForm',
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    validate,
})(CompanyModal);
